import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
// import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../Core/store.hooks";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { fetchCustomerList } from "./Slice";
import { getCustomerListSelector, loadingCustomerListSelector } from "./Slice";
import CustomerGrid from "./CustomerGrid";

interface SearchGridWidgetProps {
  id: string;
  header: string;
}

const SearchGridWidget = (props: SearchGridWidgetProps) => {
  const [customerListLoading, updateCustomerListLoading] = useState("pending");
  const [customerList, updateCustomerList] = useState([]);

  useEffect(() => {
    let newCustomerList = JSON.parse(localStorage.getItem("recentCustomers2"));
    if (newCustomerList == null || newCustomerList == undefined)
      newCustomerList = [];
    updateCustomerList(newCustomerList);
    updateCustomerListLoading("fulfilled");
  }, []);

  if (customerListLoading == "pending" || customerListLoading == undefined) {
    return <Spinner text="customer list" />;
  }
  if (customerListLoading === "rejected" || customerList.length === 0) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"Recent selected customers list not found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return <CustomerGrid data={customerList} recent={true} />;
};

export default SearchGridWidget;
